import {
  DatePicker,
  Button,
  Form,
  Input,
  Switch,
  Checkbox,
  Table,
  Select,
} from "antd";
import React, { useContext, useEffect, useState } from "react";
import {
  notifyError,
  notifySuccess,
  notifyWarning,
} from "../../../components/notification";
import { api } from "../../../services/api/api.index";
import { API_URL, API_URL_BOOK } from "../../../services/api/config";
import dayjs from "dayjs";
import { Editor } from "@tinymce/tinymce-react";
import { useRef } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import OverlaySpinner from "../../../components/overlaySpinner/OverlaySpinner";
import {
  localGetMenu,
  localRemoveMenu,
  localGetRefreshToken,
  localSaveRefreshToken,
  localSaveToken,
  localRemoveToken,
  localRemoveRefreshToken,
} from "../../../utils/localStorage";
import axios from "axios";
import { MenuOutlined } from "@ant-design/icons";
import { DndContext } from "@dnd-kit/core";
import { restrictToVerticalAxis } from "@dnd-kit/modifiers";
import {
  arrayMove,
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { geneUniqueKey } from "../../../utils/helpers/functions/textUtils";
import { UserContext } from "../../../context/context";
import moment from "moment";
import { CiCirclePlus } from "react-icons/ci";
import { RiDeleteBin2Line } from "react-icons/ri";
const { RangePicker } = DatePicker;
const BlogCreate = () => {
  const [form] = Form.useForm();
  const [dataSource, setDataSource] = useState("");
  const [subDataSource, setSubDataSource] = useState("");

  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(false);
  const [displayStatus, setDisplayStatus] = useState(false);
  const [children, setChildren] = useState([]);
  const params = useParams();
  const [groups, setGroups] = useState([]);
  const [branches, setBranches] = useState([]);
  let navigate = useNavigate();
  const [dataParents, setDataParents] = useState([]);
  const [dataParentsNew, setDataParentsNew] = useState([]);
  const [imagesCreate, setImagesCreate] = useState([]);
  const [imagesUpdate, setImagesUpdate] = useState(undefined);
  const [items, setItems] = useState([]);
  let { state: stateParent } = useLocation();

  useEffect(() => {
    if (stateParent) {
      let dataFake = [...stateParent?.parent?.children].map((x) => {
        return { value: x?._id, label: x?.name };
      });
      setDataParentsNew(dataFake);
    }
  }, [stateParent]);
  console.log(stateParent);
  // const getItems = async () => {
  //   try {
  //     let { data } = await api.get(`${API_URL}api/v1/forms/items`, {});
  //     setItems(data);
  //     getData();
  //   } catch (e) {
  //     notifyError("Chức năng đang bảo trì vui lòng thử lại sau.");
  //   }
  // };

  // const getData = async () => {
  //   setLoading(true);

  //   try {
  //     let { data } = await api.get(`${API_URL}api/v1/blogs/${params.id}`, {});
  //     form.setFieldsValue({
  //       name: data?.name,
  //       slug: data?.slug,
  //       status: data?.status === "ACTIVE" ? true : false,
  //     });
  //     setStatus(data?.status === "ACTIVE" ? true : false);
  //     setChildren(data?.relations_info);
  //     setDataSource(data?.content);
  //     setImagesUpdate(data?.image_url)
  //     setLoading(false);
  //   } catch (e) {
  //     setLoading(false);

  //     if (e.statusCode === 401) {
  //       try {
  //         let { data } = await axios({
  //           method: "POST", //you can set what request you want to be
  //           url: `${API_URL}api/v1/auth/refresh-token`,
  //           headers: {
  //             Authorization: "Bearer " + localGetRefreshToken(),
  //           },
  //         });

  //         localSaveToken(data?.data?.accessToken);
  //         localSaveRefreshToken(data?.data?.refreshToken);
  //         getData();
  //       } catch (e) {
  //         navigate("/login");
  //         notifyError("Phiên đăng nhập đã hết hạn, vui lòng đăng nhập lại!");
  //         localRemoveRefreshToken();
  //         localRemoveToken();
  //         localRemoveMenu();
  //       }
  //     } else if (e.statusCode === 403) {
  //       navigate("/login");
  //       notifyError("Phiên đăng nhập đã hết hạn, vui lòng đăng nhập lại!");
  //       localRemoveRefreshToken();
  //       localRemoveToken();
  //       localRemoveMenu();
  //     } else {
  //       if (e.statusCode < 500) {
  //         notifyWarning(e.message);
  //       } else {
  //         notifyError("Chức năng đang bảo trì vui lòng thử lại sau.");
  //       }
  //       setLoading(false);
  //     }
  //   }
  // };

  const handleDeleteImageUpdate = () => {
    setImagesUpdate(undefined);
  };

  const uploadFileHandlerUpdate = async (e) => {
    setLoading(true);
    const file = e.target.files[0];
    try {
      const { data } = await api.postMultipart(`${API_URL}api/v1/uploads`, {
        files: file,
      });
      setImagesUpdate(data[0]);
      setLoading(false);
      document.getElementById("imageFileUpdate").value = "";
      // setImage(data);
    } catch (e) {
      if (e.statusCode === 401) {
        try {
          let { data } = await axios({
            method: "POST", //you can set what request you want to be
            url: `${API_URL}api/v1/auth/refresh-token`,
            headers: {
              Authorization: "Bearer " + localGetRefreshToken(),
            },
          });

          localSaveToken(data?.data?.accessToken);
          localSaveRefreshToken(data?.data?.refreshToken);
          handleFinishFormUpdate(e);
        } catch (error) {
          navigate("/login");
          notifyError("Phiên đăng nhập đã hết hạn, vui lòng đăng nhập lại!");
          localRemoveRefreshToken();
          localRemoveToken();
          localRemoveMenu();
        }
      } else if (e.statusCode === 403) {
        navigate("/login");
        notifyError("Phiên đăng nhập đã hết hạn, vui lòng đăng nhập lại!");
        localRemoveRefreshToken();
        localRemoveToken();
        localRemoveMenu();
      } else {
        if (e.statusCode < 500) {
          notifyWarning(e.message);
        } else {
          notifyError("Chức năng đang bảo trì vui lòng thử lại sau.");
        }
        setLoading(false);
      }
    }
  };

  const getDataParent = async () => {
    setLoading(true);

    try {
      let data = await api.get(`${API_URL}api/v1/blogs`);
      let dataFake = [...data?.data].map((x) => {
        return { value: x?._id, label: x?.name };
      });
      setDataParents(dataFake);
      setLoading(false);
    } catch (e) {
      setLoading(false);

      if (e.statusCode === 401) {
        try {
          let { data } = await axios({
            method: "POST", //you can set what request you want to be
            url: `${API_URL}api/v1/auth/refresh-token`,
            headers: {
              Authorization: "Bearer " + localGetRefreshToken(),
            },
          });

          localSaveToken(data?.data?.accessToken);
          localSaveRefreshToken(data?.data?.refreshToken);
          getDataParent();
        } catch (e) {
          navigate("/login");
          notifyError("Phiên đăng nhập đã hết hạn, vui lòng đăng nhập lại!");
          localRemoveRefreshToken();
          localRemoveToken();
          localRemoveMenu();
        }
      } else if (e.statusCode === 403) {
        navigate("/login");
        notifyError("Phiên đăng nhập đã hết hạn, vui lòng đăng nhập lại!");
        localRemoveRefreshToken();
        localRemoveToken();
        localRemoveMenu();
      } else {
        if (e.statusCode < 500) {
          notifyWarning(e.message);
        } else {
          notifyError("Chức năng đang bảo trì vui lòng thử lại sau.");
        }
        setLoading(false);
      }
    }
  };

  const handleFinishFormCreate = async (value) => {
    setLoading(true);

    try {
      let { data } = await api.post(`${API_URL}api/v1/blogs`, {
        content: editorRef.current.getContent(),
        name: value?.name,
        slug: value?.slug,
        status: status ? "ACTIVE" : "INACTIVE",
        image_url: imagesUpdate,
        parent: stateParent?.parent?._id || value?.parent,
        sub_content: subEditorRef.current.getContent(),
        images: imagesCreate,
      });
      notifySuccess("Tạo bài viết thành công");
      navigate(`/blogs/${data?._id}`);
      setLoading(false);
    } catch (e) {
      if (e.statusCode === 401) {
        try {
          let { data } = await axios({
            method: "POST", //you can set what request you want to be
            url: `${API_URL}api/v1/auth/refresh-token`,
            headers: {
              Authorization: "Bearer " + localGetRefreshToken(),
            },
          });

          localSaveToken(data?.data?.accessToken);
          localSaveRefreshToken(data?.data?.refreshToken);
          handleFinishFormCreate();
        } catch (e) {
          navigate("/login");
          notifyError("Phiên đăng nhập đã hết hạn, vui lòng đăng nhập lại!");
          localRemoveRefreshToken();
          localRemoveToken();
          localRemoveMenu();
        }
      } else if (e.statusCode === 403) {
        navigate("/login");
        notifyError("Phiên đăng nhập đã hết hạn, vui lòng đăng nhập lại!");
        localRemoveRefreshToken();
        localRemoveToken();
        localRemoveMenu();
      } else {
        if (e.statusCode < 500) {
          notifyWarning(e.message);
        } else {
          notifyError("Chức năng đang bảo trì vui lòng thử lại sau.");
        }
        setLoading(false);
      }
    }
  };
  const handleDeleteListImageCreate = (image) => {
    let images = [...imagesCreate];
    images = images.filter((x) => x !== image);
    setImagesCreate(images);
  };
  const { state, dispatch } = useContext(UserContext);

  const [pageMenu, setPageMenu] = useState({
    list: false,
    details: false,
    create: false,
    update: false,
    assign: false,
    sync: false,
    import: false,
    export: false,
  });

  const uploadFileHandlerCreate = async (e) => {
    setLoading(true);
    const file = e.target.files[0];
    try {
      const { data } = await api.postMultipart(`${API_URL}api/v1/uploads`, {
        files: file,
      });
      let fakeImages = [...imagesCreate];
      fakeImages.push(data[0]);
      setImagesCreate(fakeImages);
      setLoading(false);
      document.getElementById("imageFileCreate").value = "";
    } catch (e) {
      if (e.statusCode === 401) {
        try {
          let { data } = await axios({
            method: "POST", //you can set what request you want to be
            url: `${API_URL}api/v1/auth/refresh-token`,
            headers: {
              Authorization: "Bearer " + localGetRefreshToken(),
            },
          });

          localSaveToken(data?.data?.accessToken);
          localSaveRefreshToken(data?.data?.refreshToken);
          handleFinishFormUpdate(e);
        } catch (error) {
          navigate("/login");
          notifyError("Phiên đăng nhập đã hết hạn, vui lòng đăng nhập lại!");
          localRemoveRefreshToken();
          localRemoveToken();
          localRemoveMenu();
        }
      } else if (e.statusCode === 403) {
        navigate("/login");
        notifyError("Phiên đăng nhập đã hết hạn, vui lòng đăng nhập lại!");
        localRemoveRefreshToken();
        localRemoveToken();
        localRemoveMenu();
      } else {
        if (e.statusCode < 500) {
          notifyWarning(e.message);
        } else {
          notifyError("Chức năng đang bảo trì vui lòng thử lại sau.");
        }
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    let localMenu = JSON.parse(localGetMenu());
    let fakePageMenu = { ...pageMenu };
    let fakeNewMenu = localMenu || [];
    let checkAll = fakeNewMenu.find((x) => x?.fe_route === "/forms");
    if (!checkAll) {
      navigate("/");
    } else {
      let checkView = checkAll?.permissions?.find(
        (y) => y?.permission === "VIEW_DETAIL"
      );
      if (checkView?.status === "INACTIVE") {
        navigate("/");
      } else {
        fakePageMenu = { ...fakePageMenu, details: true };
      }

      fakePageMenu = {
        ...fakePageMenu,
        create:
          checkAll?.permissions?.find((y) => y?.permission === "CREATE")
            ?.status === "ACTIVE"
            ? true
            : false,
        update:
          checkAll?.permissions?.find((y) => y?.permission === "UPDATE")
            ?.status === "ACTIVE"
            ? true
            : false,
        details:
          checkAll?.permissions?.find((y) => y?.permission === "VIEW_DETAIL")
            ?.status === "ACTIVE"
            ? true
            : false,
        assign:
          checkAll?.permissions?.find((y) => y?.permission === "ASSIGN")
            ?.status === "ACTIVE"
            ? true
            : false,
        sync:
          checkAll?.permissions?.find((y) => y?.permission === "SYNC")
            ?.status === "ACTIVE"
            ? true
            : false,
        import:
          checkAll?.permissions?.find((y) => y?.permission === "IMPORT")
            ?.status === "ACTIVE"
            ? true
            : false,
        export:
          checkAll?.permissions?.find((y) => y?.permission === "EXPORT")
            ?.status === "ACTIVE"
            ? true
            : false,
      };

      setPageMenu(fakePageMenu);
    }
  }, [state]);

  const editorRef = useRef(null);
  const subEditorRef = useRef(null);

  useEffect(() => {
    pageMenu.create && getDataParent();
  }, [pageMenu]);
  const Row = ({ children, ...props }) => {
    const {
      attributes,
      listeners,
      setNodeRef,
      setActivatorNodeRef,
      transform,
      transition,
      isDragging,
    } = useSortable({
      id: props["data-row-key"],
    });
    const style = {
      ...props.style,
      transform: CSS.Transform.toString(
        transform && {
          ...transform,
          scaleY: 1,
        }
      ),
      transition,
      ...(isDragging
        ? {
            position: "relative",
            zIndex: 99,
          }
        : {}),
    };
    return (
      <tr {...props} ref={setNodeRef} style={style} {...attributes}>
        {React.Children.map(children, (child) => {
          if (child.key === "sort") {
            return React.cloneElement(child, {
              children: (
                <MenuOutlined
                  ref={setActivatorNodeRef}
                  className="haveDrag"
                  style={{
                    touchAction: "none",
                    cursor: "move",
                  }}
                  {...listeners}
                />
              ),
            });
          }
          return child;
        })}
      </tr>
    );
  };

  const onDragEnd = ({ active, over }) => {
    if (active.id !== over?.id) {
      setItems((previous) => {
        const activeIndex = previous.findIndex((i) => i.key === active.id);
        const overIndex = previous.findIndex((i) => i.key === over?.id);
        return arrayMove(previous, activeIndex, overIndex);
      });
    }
  };

  // const addField = () => {
  //   setItems((previous) => [
  //     ...previous,
  //     {
  //       id: geneUniqueKey(),
  //       label: "",
  //       required: false,
  //       status: "INACTIVE",
  //       type: "text",
  //       code: "",
  //       name: "",
  //       key: previous.length + 2,
  //       options: [],
  //     },
  //   ]);
  // };

  return (
    pageMenu.details && (
      <>
        <OverlaySpinner text="Vui lòng đợi ..." open={loading} />
        <Form
          form={form}
          onFinish={handleFinishFormCreate}
          layout="vertical"
          className="formCreate"
          style={{
            height: "auto",
          }}
        >
          <div style={{ width: "100%" }}>
            {stateParent?.parent?.level !== 2 && (
              <div style={{ margin: "12px 0", fontSize: "14px" }}>
                <div style={{ fontWeight: "600", fontSize: "14px" }}>
                  Breadcrumb
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  {stateParent?.parent?.parent_info && (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        paddingLeft: "12px",
                        cursor: "pointer",
                        textDecoration: "underline",
                        color: "#2f86eb",
                        height: "32px",
                        fontSize: "14px",
                      }}
                    >
                      {stateParent?.parent?.parent_info?.name}
                    </div>
                  )}
                  {stateParent?.parent?.parent_info && (
                    <span>&nbsp;&nbsp;&nbsp;/&nbsp;</span>
                  )}
                  {stateParent?.parent && (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        paddingLeft: "12px",
                        cursor: "pointer",

                        textDecoration: "underline",
                        color: "#2f86eb",
                        height: "32px",
                        fontSize: "14px",
                      }}
                    >
                      {stateParent?.parent?.name}
                    </div>
                  )}
                </div>
              </div>
            )}
            <Form.Item
              name="name"
              label="Tiêu đề:"
              required
              style={{ marginBottom: "12px" }}
            >
              <Input style={{ width: "100%" }} />
            </Form.Item>
            <Form.Item
              name="slug"
              label="Slug:"
              required
              style={{ marginBottom: "12px" }}
            >
              <Input style={{ width: "100%" }} />
            </Form.Item>
            <div style={{ display: "flex" }}>
              <div>
                <div style={{}}>Hình ảnh bài viết</div>
                <div style={{ display: "flex" }}>
                  {imagesUpdate ? (
                    <div
                      style={{
                        width: "160px",
                        height: "160px",
                        border: "1px dotted #000",
                        display: "flex",
                        borderRadius: "12px",
                        alignItems: "center",
                        justifyContent: "center",
                        marginRight: "8px",
                        overflow: "hidden",
                      }}
                      className="imageGolden"
                    >
                      <div
                        className="deleteImageGolden"
                        onClick={() => handleDeleteImageUpdate()}
                      >
                        <RiDeleteBin2Line size={22} />
                      </div>
                      <img
                        src={`${API_URL_BOOK}${imagesUpdate}`}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "contain",
                        }}
                      />
                    </div>
                  ) : (
                    <div>
                      <label
                        htmlFor="imageFileUpdate"
                        style={{
                          width: "160px",
                          height: "160px",
                          border: "1px dotted #000",
                          display: "flex",
                          borderRadius: "12px",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                        }}
                      >
                        <CiCirclePlus size={40} />
                      </label>
                      <input
                        type="file"
                        id="imageFileUpdate"
                        label="Choose Image"
                        onChange={uploadFileHandlerUpdate}
                        style={{ display: "none" }}
                      ></input>
                    </div>
                  )}
                </div>
              </div>
              <Form.Item
                name="status"
                label="Trạng thái hoạt động:"
                style={{ margin: "0 0 12px 24px" }}
              >
                <Switch
                  onChange={(e) => {
                    setStatus(e);
                  }}
                />
              </Form.Item>
            </div>
          </div>
          {!stateParent && (
            <Form.Item
              label="Bài viết cha"
              name="parent"
              style={{ width: "100%", marginBottom: "12px" }}
            >
              <Select
                style={{ width: "100%" }}
                optionFilterProp="children"
                showSearch
              filterOption={(input, option) =>
                    (option?.label ?? "")
                      ?.toLowerCase()
                      .normalize("NFD")
                      .replace(/[\u0300-\u036f]/g, "")
                      .replace(/đ/g, "d")
                      .replace(/Đ/g, "D")
                      .includes(
                        input
                          .toLowerCase()
                          .normalize("NFD")
                          .replace(/[\u0300-\u036f]/g, "")
                          .replace(/đ/g, "d")
                          .replace(/Đ/g, "D")
                      )
                  }
                filterSort={(optionA, optionB) =>
                  (optionA?.label ?? "")
                    .toLowerCase()
                    .localeCompare((optionB?.label ?? "").toLowerCase())
                }
                allowClear
                options={dataParents}
                placeholder="Chọn bài viết cha"
              />
            </Form.Item>
          )}
          <div style={{ marginTop: "12px" }}>
            <p style={{ fontSize: "14px", marginBottom: "4px" }}>Nội dung:</p>
            <Editor
              onInit={(evt, editor) => (editorRef.current = editor)}
              initialValue={undefined}
              apiKey="j3su5e7yfilsrpsbi8u6m0wjdipy9i5lp9wopyvoqm1b1k6v"
              init={{
                height: 400,
                menubar: true,
                plugins:
                  "preview importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link media codesample table charmap pagebreak nonbreaking anchor insertdatetime advlist lists wordcount help charmap quickbars emoticons",
                menubar: "file edit view insert format tools table help",
                toolbar:
                  "undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media template link anchor codesample | ltr rtl",

                content_style:
                  "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
              }}
            />
            <div>Slide hình ảnh:</div>
            <div style={{ display: "flex" }}>
              {imagesCreate.length > 0 &&
                imagesCreate.map((x) => (
                  <div
                    style={{
                      width: "80px",
                      height: "80px",
                      border: "1px dotted #000",
                      display: "flex",
                      borderRadius: "12px",
                      alignItems: "center",
                      justifyContent: "center",
                      marginRight: "8px",
                    }}
                    className="imageGoldenNew"
                  >
                    <div
                      className="deleteImageGoldenNew"
                      onClick={() => handleDeleteListImageCreate(x)}
                    >
                      <RiDeleteBin2Line size={22} />
                    </div>
                    <img
                      src={`${API_URL_BOOK}${x}`}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                      }}
                    />
                  </div>
                ))}
              <div>
                <label
                  htmlFor="imageFileCreate"
                  style={{
                    width: "80px",
                    height: "80px",
                    border: "1px dotted #000",
                    display: "flex",
                    borderRadius: "12px",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                  }}
                >
                  <CiCirclePlus size={32} />
                </label>
                <input
                  type="file"
                  id="imageFileCreate"
                  label="Choose Image"
                  onChange={uploadFileHandlerCreate}
                  style={{ display: "none" }}
                ></input>
              </div>
            </div>
            <Editor
              onInit={(evt, editor) => (subEditorRef.current = editor)}
              initialValue={undefined}
              apiKey="j3su5e7yfilsrpsbi8u6m0wjdipy9i5lp9wopyvoqm1b1k6v"
              init={{
                height: 400,
                menubar: true,
                plugins:
                  "preview importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link media codesample table charmap pagebreak nonbreaking anchor insertdatetime advlist lists wordcount help charmap quickbars emoticons",
                menubar: "file edit view insert format tools table help",
                toolbar:
                  "undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media template link anchor codesample | ltr rtl",

                content_style:
                  "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
              }}
            />

            {/* <Button style={{ width: "100%" }} onClick={() => addField()}>
          Thêm field
        </Button> */}

            {pageMenu.create && (
              <div
                className="checkCustomer__content__submit"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "right",
                }}
              >
                <Button
                  style={{ width: "228px", margin: "0 24px 24px 0" }}
                  onClick={() => form.submit()}
                >
                  Tạo bài viết
                </Button>
              </div>
            )}
          </div>
        </Form>
      </>
    )
  );
};

export default BlogCreate;
